import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CharityDisplayComponent } from "./charity-display/charity-display.component";
import { CharityComponent } from "./charity/charity.component";
import { ConfirmPopupComponent } from "./confirm-popup/confirm-popup.component";
import { FilterTypesPipe } from "./control/summary-questions/not-hidden.pipe";
import { SortGroupedQuestionsPipe } from "./control/summary-questions/sort-grouped-questions.pipe";
import { SummaryQuestionsComponent } from "./control/summary-questions/summary-questions.component";
import { EditConfirmationDialogComponent } from "./edit-confirmation-dialog/edit-confirmation-dialog.component";
import { EditQuestionPopupComponent } from "./edit-question-popup/edit-question-popup.component";

/**
 * Module for all re-usable UI components including controls, pipes, directives etc
 *
 * @author Dan Bennett (dbennett)
 */
@NgModule({
    declarations: [
        CharityDisplayComponent,
        CharityComponent,
        FilterTypesPipe,
        SummaryQuestionsComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ConfirmPopupComponent,
        EditQuestionPopupComponent,
        EditConfirmationDialogComponent,
        SortGroupedQuestionsPipe
    ],
    exports: [
        CharityDisplayComponent,
        CharityComponent,
        ConfirmPopupComponent,
        FilterTypesPipe,
        SummaryQuestionsComponent
    ]
})
export class UiModule {
}
